import React, { Component } from 'react'
import ManageSets from '../../components/Content/ManageSets'
import addSet from '../../helpers/content/manageSets/addSet'
import firebase from 'firebase'
import { db } from '../../config/firebaseconfig'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as manageSetsActionCreators from '../../redux/modules/manageSets'
import forOwn from 'mout/object/forOwn'
import filterSetsBy from '../../helpers/content/manageSets/filterSetsBy'

const queryString = require('query-string')

/*
Next Step: Settings Tab
  Settings for Set:
    1. Test, Subtest, or None. If test or subtest...
    2. Assign nodeTag
    3. Time limits
    4. DisplayName
    5. Assign max nodeLevels for reports
    6. Raw to Scale scoring
*/

class ManageSetsContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      setSearch: '',
      addSetName: '',
      filterBySelected: '',
      filterText: '',
      pane: '1',
      setTestType: '',
    }

    this.handleSetSearchChange = this.handleSetSearchChange.bind(this)
    this.handleAddSetNameChange = this.handleAddSetNameChange.bind(this)
    this.handleSubmitAddSet = this.handleSubmitAddSet.bind(this)
    this.handleDeleteSet = this.handleDeleteSet.bind(this)
    this.handleFilterBySelectedChange = this.handleFilterBySelectedChange.bind(this)
    this.handleFilterTextChange = this.handleFilterTextChange.bind(this)
    this.resetFilterGenerator = this.resetFilterGenerator.bind(this)
    this.handleAddContentToSet = this.handleAddContentToSet.bind(this)
    this.handleRemoveContentFromSet = this.handleRemoveContentFromSet.bind(this)
    this.handleChangeSequence = this.handleChangeSequence.bind(this)
  }

  componentDidMount() {

    // Set up listener on sets in firestore and fetch initial sets  
    this.unsubscribe = db.collection('sets').onSnapshot((querySnapshot) => {
      this.props.fetchingSets()
      let sets = {}
      querySnapshot.forEach( (doc) => {
        let data = doc.data()
        if (!data.deleted) {
          sets[data.id] = data
        }
      })
      this.props.fetchingSetsSuccess(sets)
    }, (error) => this.props.fetchingSetsError(error))


    // Set active set based on route match.params
    if (this.props.match.params.activeSet) {
      this.props.setActiveSet(this.props.match.params.activeSet)
    }

    // Get items from firestore
    this.props.fetchingItems()
    db.collection('contentItems').get()
      .then((querySnapshot) => {
        let items = {}
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          items[data.itemId] = data
        })
        this.props.fetchingItemsSuccess(items)
      })
      .catch((error) => this.props.fetchingItemsError(error))

    // Get nodes from firestore
      this.props.fetchingNodes()
      db.collection('knowledgeMapNodes').get()
        .then((querySnapshot) => {
          let nodes = {}
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            nodes[data.id] = data
          })
          this.props.fetchingNodesSuccess(nodes)
        })
        .catch((error) => this.props.fetchingNodesError(error))


    // Set active pane based on route args
    if (this.props.location.search) {
      const query = queryString.parse(this.props.location.search)
      if (query.pane) {
        if (query.pane != this.state.pane) {
          this.setState({pane: query.pane})
        }
      }
    }

  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.pane != '1' && !nextProps.location.search) {
      this.setState({pane: '1'})
    } else if (nextProps.location.search) {
      const query = queryString.parse(nextProps.location.search)
      if (query.pane) {
        if (query.pane != this.state.pane) {
          this.setState({pane: query.pane})
        }
      } else if (this.state.pane != '1') {
        this.setState({pane: '1'})
      }
    }
    // If new route match.params gives activeSet different than in redux state, set new activeSet
    if ((this.props.activeSet !== nextProps.match.params.activeSet) && nextProps.match.params.activeSet) {
      if (nextProps.match.params.activeSet) {
        this.props.setActiveSet(nextProps.match.params.activeSet)
      } else {
        this.props.setActiveSet('')
      }
    }
  }

  handleSetSearchChange(e) {
    this.setState({
      setSearch: e.target.value,
    })
  }

  handleAddSetNameChange(e) {
    this.setState({
      addSetName: e.target.value,
    })
  }

  handleSubmitAddSet() {
    if (this.state.addSetName) {
      addSet(this.state.addSetName)
        .then((id) => {
          this.setState({
            addSetName: ''
          })
        })
        .catch((error) => console.log(error))
    }
  }

  handleFilterBySelectedChange(filterBySelected) {
    this.setState({
      filterBySelected,
    })
  }

  handleFilterTextChange(e) {
    this.setState({
      filterText: e.target.value,
    })
  }
  
  handleDeleteSet(setId) {
    db.collection('sets').doc(setId).set({
      deleted: true,
    }, {merge: true})
      .then( () => {
        if (this.props.activeSet === setId) {
          this.props.history.push('/content/sets')
        }
      })
      .catch( (error) => console.log(error))
  }

  resetFilterGenerator() {
    this.setState({
      filterBySelected: '',
      filterText: '',
    })
  }

  handleAddContentToSet(contentId) {
    if (this.props.activeSet) {
      let index = 0
      const activeSet = this.props.sets[this.props.activeSet]
      if (activeSet.content) {
        forOwn(activeSet.content, (val, key, o) => {
          val && val.active ? index++ : null
        })
      }
      activeSet.content
      ? db.collection('sets').doc(this.props.activeSet).set({
          content: {
            ...activeSet.content,
            [contentId]: {
              index,
              active: true,
            }
          }
        }, {merge: true})
        .catch((error) => console.log(error))
      : db.collection('sets').doc(this.props.activeSet).set({
          content: {
            [contentId]: {
              index,
              active: true,
            }
          }
        }, {merge: true})
        .catch((error) => console.log(error))
    }
  }

  handleRemoveContentFromSet(contentId) {
    const activeSet = this.props.sets[this.props.activeSet]
    if (activeSet.content) {
      db.collection('sets').doc(this.props.activeSet).update({
        [`content.${contentId}.active`]: false,
        [`content.${contentId}.index`]: -1,
      })
    }
  }

  handleChangeSequence(id, swapId) {
    let modifiedSet = Object.assign({}, this.props.sets[this.props.activeSet])
    const idIndex = modifiedSet.content[id].index
    const swapIdIndex = modifiedSet.content[swapId].index

    let newModifiedSet = {
      ...modifiedSet,
      content: {
        ...modifiedSet.content,
        [id]: {
          active: true,
          index: swapIdIndex,
        },
        [swapId]: {
          active: true,
          index: idIndex
        }
      }
    }

    db.collection('sets').doc(this.props.activeSet).set({
      ...newModifiedSet
    })
      .catch((err) => console.log(err))
  }

  render() {

    // computes sets matches from search bar
    let searchedSets = this.props.sets
    if (this.state.setSearch) {
      searchedSets = filterSetsBy(this.props.sets, 'name', this.state.setSearch, this.props.activeSet)
    }
    return (
      <ManageSets 
        setSearch={this.state.setSearch} 
        handleSetSearchChange={this.handleSetSearchChange}
        addSetName={this.state.addSetName}
        handleAddSetNameChange={this.handleAddSetNameChange}
        handleSubmitAddSet={this.handleSubmitAddSet}
        searchedSets={searchedSets}
        activeSet={this.props.activeSet}
        handleDeleteSet={this.handleDeleteSet}
        filters={this.props.filters}
        setItemFilter={this.props.setItemFilter}
        removeItemFilter={this.props.removeItemFilter}
        filterBySelected={this.state.filterBySelected}
        filterText={this.state.filterText}
        handleFilterTextChange={this.handleFilterTextChange}
        handleFilterBySelectedChange={this.handleFilterBySelectedChange}
        resetFilterGenerator={this.resetFilterGenerator}
        items={this.props.items}
        sets={this.props.sets}
        nodes={this.props.nodes}
        handleAddContentToSet={this.handleAddContentToSet}
        handleRemoveContentFromSet={this.handleRemoveContentFromSet}
        pane={this.state.pane}
        handleChangeSequence={this.handleChangeSequence}
        locationSearch={this.props.location.search}
      />
    )
  }

}

export default connect(
  (state) => ({
    isFetchingSets: state.manageSets.isFetchingSets,
    fetchingSetsError: state.manageSets.fetchingSetsError,
    sets: state.manageSets.sets,
    activeSet: state.manageSets.activeSet,
    filters: state.manageSets.filters,
    items: state.manageSets.items,
    isFetchingItems: state.manageSets.isFetchingItems,
    fetchingItemsError: state.manageSets.fetchingItemsError,
    nodes: state.manageSets.nodes,
    isFetchingNodes: state.manageSets.isFetchingNodes,
    fetchingNodesError: state.manageSets.fetchingNodesError,
  }),
  (dispatch) => bindActionCreators(manageSetsActionCreators, dispatch)
)(ManageSetsContainer)



// WEBPACK FOOTER //
// ./src/containers/Content/ManageSetsContainer.js